<template>

    <form ref="avaliacaoquestaotagjobs-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">
            <div class="form-group col-md-9">
                <label for="tagJobsId">Selecione a tag</label>
                <select v-select="{ dataitem: 'TagJobs', default: 'Selecione', notcache: true }" v-model="model.tagJobsId" class="form-control" name="tagJobsId" required></select>
            </div>

            <div class="col-md-3">
                <div class="btn-group float-right" style="margin-top: 30px;">
                    <button type="button" class="btn btn-success " @click="executeCreate(model)">
                        <span>Adicionar</span>
                    </button>
                </div>

            </div>
        </div>

    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "avaliacaoquestaotagjobs-form-create",
        props: { avaliacaoQuestaoId: Number },
        mixins: [base],
        data: () => ({

            model: {
                tagJobsId: ""
            },

            form: "avaliacaoquestaotagjobs-form-create",

            resources: {
                create: 'avaliacaoquestaotagjobs',
            },

        }),

        methods: {

            executeCreate: function (model) {

                if (this.formValidate() == false) return;
                this.model.avaliacaoQuestaoId = this.avaliacaoQuestaoId;

                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                var _valid = $form.checkValidity();
                if (!_valid) this.defaultErrorResult("Preencha todos os campos obrigatórios");
                return _valid;
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },
    };
</script>

